import type { FC, ReactNode } from 'react'

import {
  Checkbox,
  CheckboxProps,
  composeClasses,
  Flex,
  FlexDirectionType,
  Text
} from '@wiggot/web-components'

interface CheckboxCardProps {
  id: string
  type: CheckboxProps['type']
  dir?: FlexDirectionType
  label?: string
  icon?: ReactNode
  children?: ReactNode
  isChecked?: boolean
  isDisabled?: boolean
  onChange: (value: boolean) => void
}

export const CheckboxCard: FC<CheckboxCardProps> = ({
  id,
  type = 'checkbox',
  dir = 'row',
  label,
  icon,
  children,
  isChecked,
  isDisabled,
  onChange
}) => {
  return (
    <Checkbox
      id={id}
      type={type}
      as="button"
      gap="gap-3"
      items="start"
      justify="between"
      containerClassName={composeClasses(
        'flex-row-reverse w-full bg-surface-white hover:bg-surface-gray-10 rounded-xl p-4 outline',
        isChecked
          ? 'outline-2 outline-primary'
          : 'outline-1 outline-surface-strokes',
        isDisabled && 'outline-1 outline-surface-strokes'
      )}
      isChecked={isChecked}
      onChange={onChange}
      label={
        <Flex dir={dir} items="start" gap="gap-2">
          {icon}
          {label && <Text>{label}</Text>}
          {children}
        </Flex>
      }
      inputClassName={composeClasses(
        'min-w-[24px] min-h-[24px] w-[24px] h-[24]',
        isDisabled && 'text-terciary border-terciary'
      )}
      labelClassName={composeClasses(
        'text-[15px] font-normal',
        isDisabled && 'text-terciary'
      )}
      isDisabled={isDisabled}
    />
  )
}
